import React from 'react';
import type { Document } from '@airhead-games/shared/content';
import SectionNode from '@/content/rendering/sections/SectionNode';

interface DocumentSectionTreeProps {
  document: Document;
}

const DocumentSectionTree: React.FC<DocumentSectionTreeProps> = ({
  document,
}) => (
  <article className="flex min-w-0 flex-col gap-10">
    {document.sections.map((section) => (
      <SectionNode
        key={section.id}
        section={section}
        currentDocument={document}
      />
    ))}
  </article>
);

export default DocumentSectionTree;
